import React from "react";
import { Link } from "react-router-dom";
import { FeaturedProgrammesData } from "../../Data/FeaturedProgrammesData";
import "./FeaturedProgrammes.css";

const FeaturedProgrammes = () => {
  const activeProgrammes = FeaturedProgrammesData.getActiveProgrammes();

  if (activeProgrammes.length === 0) {
    return null;
  }

  return (
    <section className="featured-programmes-section">
      <div className="featured-programmes-header">
        <span className="featured-eyebrow">What's On Now</span>
        <h2>Featured Programmes</h2>
        <p>
          Current opportunities to learn, connect, and access support in your
          local community.
        </p>
      </div>

      <div className="featured-programmes-grid">
        {activeProgrammes.map((programme) => {
          const isUrgent = FeaturedProgrammesData.isUrgent(programme);

          return (
            <article
              key={programme.id}
              className={`featured-programme-card ${isUrgent ? "urgent" : ""}`}
            >
              <div className="programme-header">
                <div className="programme-title-wrap">
                  <span className="programme-icon" aria-hidden="true">
                    {programme.icon}
                  </span>
                  <div>
                    <h3 className="programme-title">{programme.title}</h3>
                    <p className="programme-tagline">{programme.tagline}</p>
                  </div>
                </div>

                {programme.badge && (
                  <span
                    className="programme-badge"
                    style={{ backgroundColor: programme.badgeColor }}
                  >
                    {programme.badge}
                  </span>
                )}
              </div>

              <p className="programme-description">{programme.description}</p>

              <dl className="programme-meta-grid">
                <div className="programme-meta-item">
                  <dt>Who it&apos;s for</dt>
                  <dd>{programme.targetAudience}</dd>
                </div>
                <div className="programme-meta-item">
                  <dt>Location</dt>
                  <dd>{programme.location}</dd>
                </div>
                <div className="programme-meta-item">
                  <dt>Cost</dt>
                  <dd>{programme.cost}</dd>
                </div>
              </dl>

              <div className="programme-footer">
                <span className="urgency-text">{programme.urgencyText}</span>
                <Link to={programme.ctaUrl} className="programme-cta">
                  {programme.ctaText}
                  <i className="las la-arrow-right"></i>
                </Link>
              </div>
            </article>
          );
        })}
      </div>

      <div className="featured-programmes-bottom-bar">
        <p>Need guidance on the right programme for your situation?</p>
        <Link to="/training" className="view-all-link">
          Explore all programmes
          <i className="las la-arrow-right"></i>
        </Link>
      </div>
    </section>
  );
};

export default FeaturedProgrammes;
